import { product } from "./product/product";
import {en as cart} from "./cart/index";
import { en as gonvarri } from "./gonvarri/index"
import { en as data } from "./client-program/index";
import { common } from "./project/common";
import { en as quickStock } from "./quickStock/index";
import { en as quote } from "./quote/index";
import { savedCartList } from "./cart/index";
import { en as account } from "./user/account/index";
import { en as profile } from "./user/profile/index";
import { en as ticket } from "./ticket/index"

export const en = {
  ...cart,
  ...product,
  ...gonvarri,
  ...common,
  ...quickStock,
  ...quote,
  savedCartList,
  ...account,
  ...profile,
  ...ticket,
  ...data,
}
